import React from 'react'
import './Social.css'

export default function Social() {
  return (
    <div className="Social">
      <a href="https://github.com/marianmolocea" target="blank" rel="noopener noreferrer">
        <ion-icon name="logo-github" />
      </a>
      <a href="https://www.linkedin.com/in/marian-molocea/" target="blank" rel="noopener noreferrer">
        <ion-icon name="logo-linkedin" />
      </a>
    </div>
  )
}
